import styled from "styled-components";
import { mainColor } from "../../styles/global";

export const WrapperMain = styled.div`
  padding: 3rem 7%;
  display: grid;
  place-items: center;
  gap: 2rem;
  grid-template-columns: 1fr 1fr;
  > div {
    width: 100%;
    height: 500px;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    &:hover {
      // transition: all ease-in-out 0.3s;
      // transform: scale(1.05);
      // cursor: pointer;
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 1rem 1rem;
    > div {
      width: 100%;
      height: 350px;
    }
  }
`;

export const WrapperMainOne = styled.div`
  padding: 8rem 7%;
  display: grid;
  place-items: center;
  grid-template-columns: 1fr 1fr;
  div {
    width: 100%;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      @media screen and (max-width: 540px) {
        transform: scale(0.8);
      }
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0rem 1rem;
  }
`;
export const WrapperMainTwo = styled.div`
  padding: 0.5rem 7%;
  display: grid;
  place-items: center;
  grid-template-columns: 1fr 1fr;
  div {
    width: 100%;
    img {
      width: 100%;
      margin-top: 13px;
      height: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 1rem;
    display: flex;
    flex-direction: column-reverse;

    div {
      img {
        width: 100%;
        height: 100%;
        margin-top: 0px;
      }
    }
  }
  img {
    @media screen and (max-width: 768px) {
      // width:100%;
    }
  }
`;
export const WrapperMainThree = styled.div`
  padding: 0.5rem 7%;
  display: grid;
  place-items: center;
  grid-template-columns: 1fr 1fr;
  gap: 8rem;
  div {
    width: 100%;
    img {
      width: 80%;
      margin-top: 13px;
      height: 80%;
      object-fit: contain;
      @media screen and (max-width: 540px) {
        transform: scale(0.95);
      }
    }
  }

  @media screen and (max-width: 768px) {
    gap: 5px;
    grid-template-columns: 1fr;
    padding: 1rem;
    display: flex;
    flex-direction: column-reverse;

    div {
      justify-content: center;
      align-items: center;
      flex: 1;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  img {
    @media screen and (max-width: 768px) {
      // width:100%;
    }
  }
`;
export const WrapperMainFour = styled.div`
  padding: 0.5rem 7%;
  display: grid;
  place-items: center;
  gap: 4rem;
  grid-template-columns: 1fr 1fr;
  div {
    width: 100%;
    img {
      width: 100%;
      margin-top: 13px;
    }
  }

  @media screen and (max-width: 768px) {
    gap: 0.5rem;
    grid-template-columns: 1fr;
    padding: 1rem 1rem;
  }
`;

export const WrapperMainCta = styled.div`
  padding: 3rem 7%;
  display: grid;
  place-items: center;
  gap: 2rem;
  grid-template-columns: 1fr 1fr;
  div {
    // display: flex;
    // justify-center: center;
    // align-items: center;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  @media screen and (max-width: 768px) {
    gap: 4rem;
    grid-template-columns: 1fr;
    padding: 2rem 1rem;
    > * {
      &:first-child {
        img {
          height: 450px;
          width: 100%;
        }
      }
    }
  }
`;
export const DivImg = styled.div`
  img {
    height: 100%;
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    img {
      height: 300px;
      width: 100%;
    }
  }
`;

export const WrapperHeroTwo = styled.div`
  padding: 0.5rem 7%;
  display: grid;
  place-items: center;
  gap: 9rem;
  grid-template-columns: 1.8fr 2.2fr;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 3rem 1rem;
  }
`;

export const WrapperHeroFour = styled.div`
  padding: 0.5rem 7%;
  backgroud: #fcfcfc;
  display: flex;
  place-items: center;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 3rem 1rem;
  }
`;

export const TitleText = styled.div`
  margin-bottom: 50px;
  @media screen and (max-width: 640px) {
    text-align: center;
    margin-bottom: 10px;
    font-size: 20px;
  }
  div {
    color: ${mainColor};
    font-family: "Avenir";
    font-style: normal;
    font-weight:bold;
    font-size: 34px;
    line-height: 28px;
    letter-spacing: 0.01em;
    margin: 20px 0;
    text-align: left;
    @media screen and (max-width: 768px) {
      text-align: center;
      font-size: 17px;
      margin: 0;
      padding: 0 39px;
    }
  }
  h4 {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 38px;
    letter-spacing: 0.01em;
    color: #090458;
    margin: 20px 0;
  }
`;
export const LeftSection = styled.div`
  div {
    display: flex;
    padding-top: 3rem;
    justify-content: center;
    flex-direction: column;
    @media screen and (max-width: 640px) {
      padding-top: 0rem;

    }
    img {
      width: 70%;
      @media screen and (max-width: 640px) {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 768px) {
    div {
      img {
        height: 300px;
      }
    }
  }
`;
export const RightSection = styled.div`
  // background:red;
  img {
    width: 100%;
    height: 600px;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    img {
      margin-top: 20px;
      width: 100%;
      height: 400px;
    }
  }
`;
